module.exports = __webpack_public_path__ + "img/banner-r-shadow-1.87b565e3.png";